<template>
    <div class="rank" :style="{width:rankshow?'30vw':'0'}">
        <div class="allicon" v-if="allicon">
            <img src="@/assets/game/restart_icon.png" @click="ClickRestart">
            <img src="@/assets/game/record_icon.png" @click="recorddetail">
        </div>
        <el-tabs v-model="activeName" v-show="rankshow">
        <p class="tip">您当前排名在第{{rankList.lastRank}}名 <span>数字方格(TOP 50)</span></p>
        <el-tab-pane label="排行榜" name="first">
            <ul class="ranklist" :style="'height:'+tabheight+'px'">
                <li v-for="(item) in rankList.rankList" :class="item.selfFlag?'on':''">
                    <i v-if="item.rank==1"><img src="@/assets/game/rank1.png" alt=""></i>
                    <i v-else-if="item.rank==2"><img src="@/assets/game/rank2.png" alt=""></i>
                    <i v-else-if="item.rank==3"><img src="@/assets/game/rank3.png" alt=""></i>
                    <span class="index" v-else>{{ item.rank }}</span>
                    <img :src="item.userImg" class="avatar">
                    <span class="name">{{item.realName}}</span>
                    <label class="score">{{item.result}}分</label>
                </li>
            </ul>
        </el-tab-pane>
        <el-tab-pane label="训练记录" name="second">
            <ul class="recordlist" v-infinite-scroll="recordscroll" :style="'height:'+tabheight+'px'">
                <li v-for="(item,index) in trecordlist" :class="index==0?'on':''">
                    <img v-if="index==0" src="@/assets/game/best_icon.png">
                    <p>{{item.endTimeStr}}</p>
                    <p>得分：{{item.rightRate}}分</p>
                    <p>用时：{{ Math.floor(item.totalTime/60)<10?'0'+Math.floor(item.totalTime/60):Math.floor(item.totalTime/60) }}:{{item.totalTime%60<10?'0'+item.totalTime%60:item.totalTime%60}}</p>
                </li>
                <p style="text-align: center;padding: 0 0 10px 0;font-size: 12px;">{{recordloadtext}}</p>
            </ul>

        </el-tab-pane>
    </el-tabs>
    </div>
</template>
<script>
export default{
    data() {
        return {
            activeName:"first",
            tabheight:0,
            rankList:[],
            rankshow:false,
            allicon:false,
            choosestatue:'',
            trecordlist:[],
            recordloadtext:'',
            trainrecordparams:{
                pageIndex:1,
                pageSize:10,
                count:''
            }
        }
    },
    watch:{
        activeName(newval,oldeval){
            if(newval=='first'){
                this.getinfo();
            }else{
                this.trainrecordparams.pageIndex=1;
                this.getrecord();
            }
        }
    },
    created() {
        this.getinfo();
    },
    methods: {
        // 排行榜
        getinfo(){
            this.$Http_Post('app/game/getinfo',{difficulty:this.$route.query.diffType,trainKey:this.$route.query.trainKey}).then(res=>{
                if(res.Code==0){
                    this.rankList=res.Data;
                    this.$parent.getrankDetail(res.Data);
                }else{
                    this.$message({type: 'error', message: res.Message})
                }
            })
        },
        // 训练记录
        getrecord(){
            this.$Http_Post('app/game/getrecordlist',this.trainrecordparams).then(res=>{
                if(res.Code==0){
                    if(this.trainrecordparams.pageIndex==1){
                        this.trecordlist=res.Data;
                    }else{
                        this.trecordlist=this.trecordlist.concat(res.Data);
                    }
                    this.trainrecordparams.count=res.Counts
                }else{
                    this.$message({type: 'error', message:"获取训练记录失败"})
                }
            });
        },

        // 选中状态
        chooseRank(rank){
            this.choosestatue=rank;
        },

        ClickRestart(){
            this.$parent.RestartGame();
        },
        
        recorddetail(){
            var _this=this;
            this.rankshow=!this.rankshow;
            if(this.rankshow){
                this.getinfo();
                setTimeout(function(){
                    let tab=document.getElementsByClassName('rank')[0].clientHeight;
                    let header=document.getElementsByClassName('el-tabs__header')[0].clientHeight;
                    let tip=document.getElementsByClassName('tip')[0].clientHeight;
                    _this.tabheight=tab-header-tip;
                },500);
            }
        },
        actionicon(){
            let _this=this;
            this.allicon=true;
            this.rankshow=false;
            setTimeout(function(){
                _this.allicon=false;
            },3000);
        },
        // 滚动条
        recordscroll(){
            if(Math.ceil(this.trainrecordparams.count/this.trainrecordparams.pageSize)>this.trainrecordparams.pageIndex){
                this.recordloadtext='数据加载中···'
                this.trainrecordparams.pageIndex+=1;
                this.getrecord();
            }else{
                this.recordloadtext='暂无更多';
                this.recordloadtext=this.trainrecordparams.count<10?'':this.recordloadtext;
            }
        }
    },
}
</script>
<style>
.rank{background:rgb(255 195 0 / 15%);width: 30vw;position: relative;}
.rank .el-tabs__header{margin: 0;}
.rank .tip{color: #848484;padding:.5vw 1vw;background:rgb(255 195 0 / 40%);text-align: left;font-size: 12px;line-height: 1;}
.rank .tip span{float: right;font-size: 12px;}
.rank .is-active{background-color:rgb(255, 195, 0)!important;color: #fff!important;}
.rank .el-tabs__nav{width: 100%;}
.rank .el-tabs__item{background-color:rgb(235, 235, 235);color:rgb(190, 190, 190);width:50%;text-align: center;padding: 0;}
.rank .el-tabs__active-bar{background:none;}
.rank .ranklist{overflow-y: auto;}
.rank .ranklist li{font-size: 12px;width:100%;display: flex;align-items: center;padding:.5vw 0;}
.rank .ranklist li.on{background: rgba(255, 233, 161, 1);}
.rank .ranklist li i{width:10%;display: inline-block;text-align: center;}
.rank .ranklist li .index{width: 10%;display: inline-block;text-align: center;}
.rank .ranklist li .avatar{width: 2.464vw;height:2.464vw;border-radius: 50%;margin: 0 .5vw;}
.rank .ranklist li .name{width:50%;display: inline-block;}
.rank .ranklist li .name .score{width:20%;display: inline-block;}
.rank .allicon{position: fixed;top:50%;right:0;width:4vw;transform: translate(0,-50%);z-index: 2;}
.rank .allicon img{width:100%;}
.rank .recordlist{overflow-y: auto;}
.rank .recordlist li{background:#fff;border-radius:8px;margin:1em auto;width: 80%;text-align: center;font-size: 12px;padding:.5em 0;position:relative;}
.rank .recordlist li.on{background: #FFC300;color: #fff;}
.rank .recordlist li.on img{width: 3em;position: absolute;top: 1em;left: 0.5em;}
.rank .recordlist li p{padding:.3em;}
</style>